var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalhistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 84.327,
    y: 60.281,
    style: {
      fill: "#FED9A8"
    },
    width: 342.94,
    height: 443.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.645,
    y: 60.281,
    style: {
      fill: "#EFC48F"
    },
    width: 23.614,
    height: 443.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.774,
    y: 60.302,
    style: {
      fill: "#F2F2F2"
    },
    width: 303.181,
    height: 413.815
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.636,
    y: 60.302,
    style: {
      fill: "#E6E6E6"
    },
    width: 23.312,
    height: 413.815
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37CC8F"
    },
    points: "310.958,162.858 273.077,162.858 273.077,124.976 238.513,124.976 238.513,162.858  200.632,162.858 200.632,197.421 238.513,197.421 238.513,235.302 273.077,235.302 273.077,197.421 310.958,197.421 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A6747"
    },
    d: "M287.448,31.136v-8.103c0-8.391-6.802-15.193-15.193-15.193h-32.92 c-8.391,0-15.193,6.802-15.193,15.193v8.103h-62.547v58.749h188.399V31.136H287.448z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.931,
    y: 31.135,
    style: {
      fill: "#7F5C40"
    },
    width: 23.697,
    height: 58.751
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.904,283.001c4.33,0,7.839-3.51,7.839-7.839s-3.509-7.839-7.839-7.839h-24.814c-4.33,0-7.839,3.51-7.839,7.839 s3.509,7.839,7.839,7.839H387.904z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.258,275.162c0,4.329,3.51,7.839,7.839,7.839h213.2c4.33,0,7.839-3.51,7.839-7.839s-3.509-7.839-7.839-7.839h-213.2 C119.768,267.323,116.258,270.833,116.258,275.162z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.097,339.674h263.806c4.33,0,7.839-3.51,7.839-7.839c0-4.329-3.509-7.839-7.839-7.839H124.097 c-4.329,0-7.839,3.51-7.839,7.839C116.258,336.164,119.768,339.674,124.097,339.674z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.097,396.348h263.806c4.33,0,7.839-3.51,7.839-7.839c0-4.329-3.509-7.839-7.839-7.839H124.097 c-4.329,0-7.839,3.51-7.839,7.839C116.258,392.838,119.768,396.348,124.097,396.348z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387.904,437.342H320.41c-4.33,0-7.839,3.51-7.839,7.839c0,4.329,3.509,7.839,7.839,7.839h67.494 c4.33,0,7.839-3.51,7.839-7.839C395.743,440.852,392.233,437.342,387.904,437.342z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.282,117.138h-34.563c-4.329,0-7.839,3.51-7.839,7.839v30.042h-30.042c-4.329,0-7.839,3.51-7.839,7.839v34.564 c0,4.329,3.51,7.839,7.839,7.839h30.042v30.042c0,4.329,3.51,7.839,7.839,7.839h34.563c4.33,0,7.839-3.51,7.839-7.839V205.26h30.042 c4.33,0,7.839-3.51,7.839-7.839v-34.564c0-4.329-3.509-7.839-7.839-7.839h-30.042v-30.042 C281.121,120.647,277.611,117.138,273.282,117.138z M303.324,170.697v18.886h-30.042c-4.33,0-7.839,3.51-7.839,7.839v30.042h-18.885 v-30.042c0-4.329-3.51-7.839-7.839-7.839h-30.042v-18.886h30.042c4.329,0,7.839-3.51,7.839-7.839v-30.042h18.885v30.042 c0,4.329,3.509,7.839,7.839,7.839H303.324z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M427.468,52.441h-69.43V31.136c0-4.329-3.509-7.839-7.839-7.839h-54.708v-0.264C295.492,10.333,285.159,0,272.46,0h-32.92 c-12.7,0-23.032,10.333-23.032,23.033v0.264h-54.708c-4.329,0-7.839,3.51-7.839,7.839v21.305h-69.43 c-4.329,0-7.839,3.51-7.839,7.839v98.124c0,4.329,3.51,7.839,7.839,7.839c4.329,0,7.839-3.51,7.839-7.839V68.119h61.59v21.765 c0,4.329,3.51,7.839,7.839,7.839l0,0h188.399c4.33,0,7.839-3.51,7.839-7.839V68.119h61.591v428.203H92.37V184.229 c0-4.329-3.51-7.839-7.839-7.839c-4.329,0-7.839,3.51-7.839,7.839v319.932c0,4.329,3.51,7.839,7.839,7.839h342.937 c4.33,0,7.839-3.51,7.839-7.839V60.28C435.307,55.951,431.799,52.441,427.468,52.441z M342.361,82.045H169.64V60.28 c0-0.003,0-0.006,0-0.01V38.975h54.708c4.329,0,7.839-3.51,7.839-7.839v-8.103c0-4.055,3.299-7.355,7.354-7.355h32.92 c4.055,0,7.354,3.3,7.354,7.355v8.103c0,4.329,3.509,7.839,7.839,7.839h54.708v21.305V82.045z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalhistory);
export default __webpack_public_path__ + "static/media/medicalhistory.5de8b7fa28ea2991e1287709890b4692.svg";
export { ForwardRef as ReactComponent };